module.exports = __webpack_public_path__ + "img/sld_scb_39_t1_b1_green.754e448a.svg";